import axios from 'axios'

const changeUsePassword = async (userData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/resetPassword`,
      userData,
      {
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default changeUsePassword
